import { PayloadAction } from '@reduxjs/toolkit';

import { ILoyaltyTransactionV2 } from 'generated/graphql-gateway';
import { createAppSlice } from 'state/global-state/utils';
import { LoyaltyUser } from 'state/loyalty/hooks/types';

import { IUserState } from './user.types';

export const initialState: IUserState = {
  loyaltyUser: null,
  loyaltyLoading: false,
  loyaltyUserTransactions: [],
};

export const userSlice = createAppSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<LoyaltyUser | null>) => {
      state.loyaltyUser = payload;
    },
    setLoyaltyLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loyaltyLoading = payload;
    },
    setUserTransactions: (state, { payload }: PayloadAction<ILoyaltyTransactionV2[]>) => {
      state.loyaltyUserTransactions = payload;
    },
  },
});
